import axios from "axios";
import { EventBus } from './event-bus.js';
import constants from "../constants";

export default {
    saveCustomDataList(dataList, dataListId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/custom-data-list/" + dataListId, dataList).then(response => {
            return response.data;

        }).catch(error => {
            return error.response.data;
        });
    },
    getCustomDataList(input) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/custom-data-list?" + input, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching Custom data list"
                    });
                }
            });
    },
    getExternalSystemsData() {
        var msgType = "FetchSuccess";
        return axios.get(constants.BASE_URL + "/integrate/external-systems", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "FetchError";
            })
            .finally(() => {
                if (msgType == 'FetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching External systems data"
                    });
                }
            });
    },
    getAPIsData(externalSystemId) {
        var msgType = "FetchSuccess";
        return axios.get(constants.BASE_URL + "/integrate/external-systems/apis/" + externalSystemId, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "FetchError";
            })
            .finally(() => {
                if (msgType == 'FetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching External systems API data"
                    });
                }
            });
    },
    getAdaptersData(apiId, connectionType) {
        var msgType = "FetchSuccess";
        var url = "/integrate/external-systems/sql-adapters/" + apiId + "?loadParams=false";

        if (connectionType === "REST") {
            url = "/integrate/external-systems/rest-adapters/" + apiId + "?loadParams=false";
        } else if (connectionType === "FILE") {
            url = "/integrate/external-systems/file-adapters/" + apiId + "?loadParams=false";
        }
        return axios.get(constants.BASE_URL + url, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "FetchError";
            })
            .finally(() => {
                if (msgType == 'FetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching External systems adapters data"
                    });
                }
            });
    },
    getParametersData(adapterId, type) {
        var msgType = "FetchSuccess";
        var url = "/integrate/external-systems/sql-adapter-params/" + adapterId;

        if (type === "REST") {
            url = "/integrate/external-systems/rest-adapter-params/" + adapterId;
        } else if (type === "FILE") {
            url = "/integrate/external-systems/file-adapter-params/" + adapterId;
        }

        return axios.get(constants.BASE_URL + url, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "FetchError";
            })
            .finally(() => {
                if (msgType == 'FetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching parameters data"
                    });
                }
            });
    },
    getDataList(dataListId) {
        var msgType = "FetchSuccess";
        return axios.get(constants.BASE_URL + "/custom-data-list/" + dataListId, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "FetchError";
            })
            .finally(() => {
                if (msgType == 'FetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching custom data list"
                    });
                }
            });
    },
    testAdapter(url) {
        var msgType = "testAdapterSuccess";
        return axios.get(constants.BASE_URL + url, {
            withCredentials: true
        })
            .then(response => {
                return response;
            })
            .catch(error => {
                msgType = "testAdapterError";
            })
            .finally(() => {
                if (msgType == 'testAdapterError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while testing adapter"
                    });
                }
            });
    }
} 